import { useEffect, useState } from "react";
import { ExternalLink, X } from "lucide-react";

const PRODUCTION_URL = "https://stock-request-hub-3.emergent.host";
const DISMISS_KEY = "cb_preview_banner_dismissed_v1";

// Visible only when the app is loaded from the Emergent preview origin
// (the editor's iframe URL). On production / installed PWA this returns
// null so it never shows up. Dismissible per session.
function isPreviewHost() {
  if (typeof window === "undefined") return false;
  return /preview\.emergentagent\.com$/i.test(window.location.hostname);
}

export default function PreviewBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isPreviewHost()) return;
    if (sessionStorage.getItem(DISMISS_KEY) === "1") return;
    setShow(true);
  }, []);

  if (!show) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  return (
    <div
      data-testid="preview-banner"
      className="fixed top-0 inset-x-0 z-[70] bg-[#F5C451] text-[#0B1F3A] border-b border-[#D8A82F] shadow-[0_2px_8px_-2px_rgba(11,31,58,0.15)]"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="max-w-5xl mx-auto px-4 py-2 flex items-center gap-3 text-[13px]">
        <span
          className="inline-block h-2 w-2 rounded-full bg-[#0B1F3A] flex-shrink-0"
          aria-hidden="true"
        />
        <div className="flex-1 min-w-0">
          <span className="font-medium">Estás en la versión preview.</span>{" "}
          <span className="opacity-80">
            Para instalar la app en tu equipo, abrí la versión de producción.
          </span>
        </div>
        <a
          href={PRODUCTION_URL}
          data-testid="preview-banner-open-prod"
          className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#0B1F3A] text-white text-[12px] font-medium hover:bg-[#0B1F3A]/85 transition-colors"
        >
          <ExternalLink size={12} />
          Abrir producción
        </a>
        <a
          href={PRODUCTION_URL}
          data-testid="preview-banner-open-prod-mobile"
          aria-label="Abrir producción"
          className="sm:hidden inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#0B1F3A] text-white"
        >
          <ExternalLink size={14} />
        </a>
        <button
          type="button"
          onClick={dismiss}
          data-testid="preview-banner-dismiss"
          aria-label="Cerrar aviso"
          className="inline-flex items-center justify-center w-7 h-7 rounded-full hover:bg-black/10 transition-colors"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
